module.exports = require("core-js/library/fn/set");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/set.js
// module id = 639
// module chunks = 0